// Radha — German (de-DE) locale pack.
// Shell chrome only: nav, header, repeated states and actions. Panel body
// copy is intentionally absent — it is finance/legal terminology that needs
// native review, and t() falls back to English until it is translated.
const de = {
  "nav.overview": "Übersicht",
  "nav.collections": "Forderungen",
  "nav.disputes": "Streitfälle",
  "nav.contracts": "Verträge",
  "nav.invoicing": "Rechnungsstellung",
  "nav.recurring": "Wiederkehrend",
  "nav.statements": "Kontoauszüge",
  "nav.creditNotes": "Gutschriften",
  "nav.gst": "Steuer",
  "nav.tax": "Steuer & E-Rechnung",
  "nav.reconciliation": "Abstimmung",
  "nav.deductions": "Abzüge",
  "nav.withholding": "Quellensteuer",
  "nav.cashflow": "Cashflow",
  "nav.crm": "CRM",
  "nav.forecasts": "Prognosen",
  "nav.reminders": "Erinnerungen",
  "nav.dunning": "Mahnwesen",
  "nav.automation": "Automatisierung",
  "nav.settings": "Einstellungen",
  "nav.privacy": "Datenschutz",
  "group.receivables": "Forderungen",
  "group.planning": "Planung",
  "group.operations": "Betrieb",
  "group.admin": "Administration",
  "app.tagline": "Revenue Operating System",
  "app.signOut": "Abmelden",
  "app.search": "Suchen",
  "app.toggleTheme": "Farbschema wechseln",
  "app.toggleNav": "Navigation umschalten",
  "app.language": "Sprache",
  "app.useTenantDefault": "Mandanten-Standard verwenden",
  "state.loading": "Wird geladen…",
  "state.error": "Daten konnten nicht geladen werden",
  "state.empty": "Noch nichts vorhanden",
  "state.readOnly": "Nur Lesezugriff",
  "action.approve": "Genehmigen",
  "action.reject": "Ablehnen",
  "action.save": "Speichern",
  "action.saving": "Wird gespeichert…",
  "action.saved": "Gespeichert",
  "action.cancel": "Abbrechen",
  "action.export": "Nach Excel exportieren",
};
export default de;
